// eslint-disable-next-line
export function errorHandle(err: any, message: string = 'Houve algun erro. Tente novamente'): string {
    return err?.response?.data[0]?.errorMessage ?? err?.message ?? err ?? message
}